<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
    <div class="flex justify-between">
      <drdp-title title= {{title}}></drdp-title>
    </div>

    <drdp-student-demographics [state]="currentState"></drdp-student-demographics>

    @for (permission of permissions; track $index) {
      <drdp-container additionClasses="h-min mt-5">
        <drdp-state-dashboard [stateId]="currentState?.id" [permission]="permission"></drdp-state-dashboard>
      </drdp-container>
    }

    <drdp-container [additionClasses]="'h-min mt-5'">
      <drdp-child-upload [stateId]="currentState?.id"></drdp-child-upload>
    </drdp-container>

    <drdp-container [additionClasses]="'h-min mt-5'">

      <div class="w-full">
        <h1 class="text-2xl font-medium">{{ t('stateConfiguration.customConfigurations') }}</h1>
        <drdp-add-edit-table [dataSource]="dataSource"
                             [tableData]="tableData"
                             [columns]="tableColumns"
                             (editActionItem)="openModal($event)">
        </drdp-add-edit-table>

        <div class="col-span-2 w-[100%] h-min">
          <div class="flex justify-end w-[100%]"><drdp-btn (click)="openModal(null, currentState?.id)"><i class="uil uil-plus"></i>{{ t('stateConfiguration.addAlternateConfiguration') }}</drdp-btn>
          </div>
      </div>

      </div>
    </drdp-container>

    <drdp-container [additionClasses]="'h-min mt-5'">
      <div class="w-full">
        <h1 class="text-2xl font-medium">{{ t('stateConfiguration.ratingViews') }}</h1>
        <form [formGroup]="ratingViewsForm" class="mt-4">
          <div class="space-y-4">
            <div>
              <label class="font-semibold required">{{ t('stateConfiguration.ratingViewVersion') }}</label>
              <mat-radio-group
                [attr.aria-label]="t('stateConfiguration.ratingViewVersionAriaLabel')"
                class="flex gap-6 mt-2"
                formControlName="ratingViewVersion">
                @for (option of ratingViewOptions; track option.id) {
                  <!-- Server-supplied rating view version name. -->
                  <mat-radio-button [value]="option.versionName" color="primary">{{ option.displayName }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>
            <div>
              <mat-checkbox formControlName="showAlternateRatingViews" class="mt-2">
                {{ t('ratingViewSetup.alternateRatingViews') }}
              </mat-checkbox>
            </div>
          </div>
        </form>
        <div class="mt-4 flex justify-end">
          <drdp-btn (click)="saveRatingViewsConfiguration()" 
            [disabled]="ratingViewsForm.invalid">
            {{ t('common.saveAndSubmit') }}
          </drdp-btn>
        </div>
      </div>
    </drdp-container>

    <drdp-container [additionClasses]="'h-min mt-5'">
      <div class="w-full">
        <h1 class="text-2xl font-medium">{{ t('stateConfiguration.schoolYearTarget') }}</h1>
        <drdp-add-edit-table [dataSource]="dataSource" [tableData]="targetTableData" [columns]="targetColumns" 
          (editActionItem)="openTargetModal($event, currentState?.id)" (deleteActionItem)="deleteTargetModal($event)"> 
        </drdp-add-edit-table>
        <div class="col-span-2 w-[100%] h-min">
          <div class="flex justify-end w-[100%]">
            <drdp-btn (click)="openTargetModal(null, currentState?.id)"><i class="uil uil-plus"></i>
              {{ t('stateConfiguration.target.addTitle') }}</drdp-btn>
          </div>
        </div>
      </div>
    </drdp-container>

</div>
</ng-container>
